import React from 'react';
import { Link } from '@nextroll/ar-container-app';
import i18n from '@nextroll/ar-i18n';

import { getNodeHeaderHelpText } from './nodeHeaderHelpTextMap';

interface NodeHeaderHelpTextProps {
    serviceTitle: string;
    actionEid: string;
}

/**
 *  This component is used to map an action eid to help text displayed on the top of the node header
 */
export const NodeHeaderHelpSection = ({ serviceTitle, actionEid }: NodeHeaderHelpTextProps) => {
    const helpTextMapping = getNodeHeaderHelpText(serviceTitle, actionEid);
    if (!helpTextMapping) {
        return null;
    }
    return (
        <div className='workflow-node-panel-header-container-help-section'>
            <div className='workflow-node-panel-header-container-help-section-text'>
                {helpTextMapping.helpText}
            </div>
            <Link
                to={helpTextMapping.linkTo}
                openNewWindow
                rel='noopener noreferrer'
            >
                {i18n.gettext('AdRoll Help Center:')}&nbsp;{helpTextMapping.linkText}
            &nbsp;
                <i className='ar-icon ar-icon-fw fa-external-link-alt' />
            </Link>
        </div>
    );
};
